
<section id="foundations-endowments">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Investing for Catholics Disclosures and Policies</h1>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-lg-3">
           <div class="btn-group mb-3 dropdown">
            <button id="button-animated" type="button" class="btn btn-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              Other Disclosures
            </button>
            <ul class="dropdown-menu" aria-labelledby="button-animated">
              <li><a class="dropdown-item" href="/disclosures/index-data">IFC Indexes Data Sources</a></li>
              <li><a class="dropdown-item" href="https://www.ifa.com/pdfs/ifc-form-adv-2a-and-2b-04-24-2023.pdf" target="_blank">Form ADV</a></li>
              <!-- <li><a class="dropdown-item" href="/disclosures/history">History of Changes</a></li> -->
              <li><a class="dropdown-item" href="https://www.ifa.com/pdfs/privacypolicy.pdf" target="_blank">Privacy Policy</a></li>
            </ul>
          </div>
      </div>
      <div class="col-lg-9">
        <h3>DISCLOSURES FOR THE HYPOTHETICAL BACKTESTED PERFORMANCE OF THE INVESTING FOR CATHOLICS MODEL INDEX PORTFOLIOS AND INDEXES:</h3>
        @if (disclosures) {
          <div [innerHtml]="disclosures[0].html | safe: 'html'"></div>
        }
      </div>
    </div>
  </div>
</section>